/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AcceptExistingTeamInvitationRequest } from '../models/AcceptExistingTeamInvitationRequest';
import type { AcceptTeamInvitationRequest } from '../models/AcceptTeamInvitationRequest';
import type { ApiResponseDTOInvitationDetails } from '../models/ApiResponseDTOInvitationDetails';
import type { ApiResponseDTOTeamMembersResponse } from '../models/ApiResponseDTOTeamMembersResponse';
import type { ApiResponseDTOUserManagementDTO } from '../models/ApiResponseDTOUserManagementDTO';
import type { ApiResponseDTOVoid } from '../models/ApiResponseDTOVoid';
import type { CreateTeamMemberRequest } from '../models/CreateTeamMemberRequest';
import type { UserManagementParametersRecord } from '../models/UserManagementParametersRecord';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export type TeamRoleGuideSectionDTO = {
    name?: string;
    actions?: Array<string>;
};

export type TeamRoleGuideDTO = {
    summary?: Array<string>;
    conditions?: Array<string>;
    sections?: Array<TeamRoleGuideSectionDTO>;
};

export type UserManagementDetailsDTO = {
    userId?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    phoneNumber?: string;
    role?: string;
    status?: 'PENDING' | 'ACTIVE' | 'INACTIVE';
    owner?: boolean;
    allOutlets?: boolean;
    numberOfOutlets?: number;
    outlets?: Array<{ outletId?: string; name?: string }>;
    joinedAt?: string;
    /** This member's role permission keys - owner and admin hold all 16. */
    permissions?: Array<string>;
    /** For "View permission breakdown" - this member's role, not the
     * signed-in viewer's. */
    accessGuide?: TeamRoleGuideDTO;
};

export type ApiResponseDTOUserManagementDetails = {
    success?: boolean;
    message?: string;
    data?: UserManagementDetailsDTO;
};

export class TeamManagementControllerService {

    /**
     * @param requestBody
     * @returns ApiResponseDTOUserManagementDTO Created
     * @throws ApiError
     */
    public static create(
        requestBody: CreateTeamMemberRequest,
    ): CancelablePromise<ApiResponseDTOUserManagementDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/corporate/team/invitations',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                422: `Unprocessable Entity`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns ApiResponseDTOVoid OK
     * @throws ApiError
     */
    public static accept(
        requestBody: AcceptTeamInvitationRequest,
    ): CancelablePromise<ApiResponseDTOVoid> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/corporate/team/invitations/accept',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                422: `Unprocessable Entity`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param token
     * @returns ApiResponseDTOInvitationDetails OK
     * @throws ApiError
     */
    public static resolve(
        token: string,
    ): CancelablePromise<ApiResponseDTOInvitationDetails> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/corporate/team/invitations/{token}',
            path: {
                'token': token,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                422: `Unprocessable Entity`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param userId
     * @returns ApiResponseDTOVoid OK
     * @throws ApiError
     */
    public static resend(
        userId: string,
    ): CancelablePromise<ApiResponseDTOVoid> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/corporate/team/invitations/{userId}/resend',
            path: {
                'userId': userId,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                422: `Unprocessable Entity`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param parameters
     * @returns ApiResponseDTOTeamMembersResponse OK
     * @throws ApiError
     */
    public static list(
        parameters: UserManagementParametersRecord,
    ): CancelablePromise<ApiResponseDTOTeamMembersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/corporate/team/members',
            query: {
                ...parameters,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                422: `Unprocessable Entity`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param userId
     * @param action
     * @returns ApiResponseDTOVoid OK
     * @throws ApiError
     */
    public static deleteInvited(
        userId: string,
        action: string,
    ): CancelablePromise<ApiResponseDTOVoid> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/corporate/team/members/{userId}',
            path: {
                'userId': userId,
            },
            query: {
                'action': action,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                422: `Unprocessable Entity`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns ApiResponseDTOVoid OK
     * @throws ApiError
     */
    /**
     * Accepts an invitation as a user who already has a Finopay login.
     *
     * @param requestBody the invitation token from the link
     * @param authorization the signed-in user's access token
     *
     * Unlike the rest of the app this cannot lean on the Axios interceptor that
     * installs the `Authorization` header: that interceptor lives in `TokenHOC`,
     * and the invitation routes sit outside it. Without an explicit header the
     * call goes out unauthenticated and answers 401 even for a signed-in user.
     */
    public static acceptExisting(
        requestBody: AcceptExistingTeamInvitationRequest,
        authorization?: string,
    ): CancelablePromise<ApiResponseDTOVoid> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/corporate/team/memberships/accept',
            headers: authorization
                ? { Authorization: `Bearer ${authorization}` }
                : undefined,
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                422: `Unprocessable Entity`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Hand-written: not in the generated client yet.
     * PUT /api/corporate/team/members/{userId} - body { role, outletIds }.
     * An admin takes no outlets; every other role needs at least one.
     */
    public static updateMember(
        userId: string,
        requestBody: { role: string; outletIds: string[] },
    ): CancelablePromise<ApiResponseDTOVoid> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/corporate/team/members/{userId}',
            path: {
                'userId': userId,
            },
            // The API speaks lowercase roles ("admin", "cashier") and rejects
            // anything else as a bad request, while the app holds them
            // uppercase.
            body: { ...requestBody, role: requestBody.role.toLowerCase() },
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                422: `Unprocessable Entity`,
            },
        });
    }

    /**
     * Hand-written: not in the generated client yet.
     * GET /api/corporate/team/members/{userId} - one member with its access.
     *
     * Unlike the list, this reports outlets by id, so it is what the edit
     * screen pre-fills from.
     */
    public static getMember(
        userId: string,
    ): CancelablePromise<ApiResponseDTOUserManagementDetails> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/corporate/team/members/{userId}',
            path: {
                'userId': userId,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                422: `Unprocessable Entity`,
            },
        });
    }

    /**
     * Hand-written: not in the generated client yet.
     * POST /api/corporate/team/members/{userId}/enable - re-enables a disabled
     * member.
     */
    public static enableMember(
        userId: string,
    ): CancelablePromise<ApiResponseDTOVoid> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/corporate/team/members/{userId}/enable',
            path: {
                'userId': userId,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                422: `Unprocessable Entity`,
            },
        });
    }

}
